import { FirstVisitChecker, PastVisitPlaceEntity } from 'src/entities/PastVisitPlace.entity';

/**
 * past_visits（過去 3 ヶ月の訪問済み地点）のレスポンスから初訪問判定関数を作る。
 *
 * 判定はサーバーではなくここで行う。API は当日を含まない過去側だけを返すため、
 * 当日の配車をいくら保存してもこの入力は変わらない（= 重いクエリを再実行しなくて済む）。
 *
 * 「初訪問」の条件は 2 つ。
 * - その shift_truck の担当ドライバーが過去 3 ヶ月に 1 度でも訪問実績を持つこと。
 *   実績ゼロのドライバー（新人など）は全地点が「初」になってしまうためアイコンを出さない
 *   （旧 API がサーバー側で行っていた drivers_with_past_data 判定と同じ UX）。
 * - その地点が訪問済み集合に無いこと。
 */
export const buildFirstVisitChecker = (
  pastVisitPlaces: PastVisitPlaceEntity[] | undefined,
): FirstVisitChecker => {
  const visited = new Set<string>();
  const shiftTrucksWithPastData = new Set<number>();

  (pastVisitPlaces ?? []).forEach((p) => {
    if (p.shiftTruckId == null || p.latitude == null || p.longitude == null) return;
    const key = normalizedKey(p.shiftTruckId, p.latitude, p.longitude);
    if (key == null) return;
    visited.add(key);
    shiftTrucksWithPastData.add(p.shiftTruckId);
  });

  return (shiftTruckId, latitude, longitude) => {
    if (shiftTruckId == null) return false;
    if (!shiftTrucksWithPastData.has(shiftTruckId)) return false;
    const key = normalizedKey(shiftTruckId, latitude, longitude);
    if (key == null) return false;
    return !visited.has(key);
  };
};

// "35.10" / "35.1" のような末尾ゼロ・桁差を吸収するため Number で正規化したキーにする。
const normalizedKey = (
  shiftTruckId: number,
  latitude: string | null | undefined,
  longitude: string | null | undefined,
): string | null => {
  if (latitude == null || longitude == null) return null;
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  return `${shiftTruckId}|${lat}|${lng}`;
};
